import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LocationConfirmInfo } from "../models/LocationConfirmInfo";
import { LocationConfirmItem } from "../models/LocationConfirmItem";


@Injectable({
    providedIn: 'root'
})
export class LocationConfirmationService {

    constructor(private http: HttpClient) {

    }

    getConfirmInfo(confirmInfo: LocationConfirmInfo): Observable<LocationConfirmInfo> {
        return this.http.post<LocationConfirmInfo>('api/locationconfirm/GetConfirmInfo', confirmInfo);
    }

    getLocationDispatchInfo(confirmInfo: LocationConfirmInfo): Observable<LocationConfirmItem[]> {
        return this.http.post<LocationConfirmItem[]>('api/locationconfirm/GetLocationDispatchInfo', confirmInfo);
    }

    sendConfirmation(confirmInfo: LocationConfirmInfo): Observable<boolean> {
        return this.http.post<boolean>('api/locationconfirm/SendConfirmation', confirmInfo);
    }

    getReportContent(confirmInfo: LocationConfirmInfo): Observable<Blob> {
        return this.http.post('api/locationconfirm/GetReportContent', confirmInfo, { responseType: 'blob' });
    }

}

